import type { Conversation, ConversationDraft } from "../types";

export const startMessageEdit = (conversation: Conversation, messageId: string): Conversation => {
  const message = conversation.messages.find((item) => item.id === messageId && item.role === "user");
  if (!message) return conversation;
  return { ...conversation, draft: {
    content: message.content, attachments: message.attachments ?? [], editingMessageId: messageId,
    beforeEdit: conversation.draft?.beforeEdit ?? { content: conversation.draft?.content ?? "", attachments: conversation.draft?.attachments ?? [] },
  } };
};

export const cancelMessageEdit = (conversation: Conversation): Conversation => ({ ...conversation, draft: conversation.draft?.beforeEdit });

export const updateDraft = (conversation: Conversation, patch: Partial<ConversationDraft>): Conversation => ({
  ...conversation,
  draft: { content: "", attachments: [], ...conversation.draft, ...patch },
});
